// Pinia Store
import { defineStore } from 'pinia'

import { LANGUAGE_LOADED_STATUS } from '@/constants'

import languageFrench from '@/data/french.json'

interface State {
  content: Record<string, any>
  languageSelected: string
  status: LANGUAGE_LOADED_STATUS
}

export const useLanguageStore = defineStore('language', {
  // convert to a function
  state: (): State => ({
    content: languageFrench,
    languageSelected: 'FR',
    status: LANGUAGE_LOADED_STATUS.LOADED,
  }),

  getters: {
    text: (state) => {
      return (key: string) => state.content[key]
    },

    getLanguageSelected: (state) => {
      return state.languageSelected
    },

    getStatus: (state) => {
      return state.status
    },
  },

  actions: {},
})
